var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.9978 8.99999V13M11.9978 17H12.0078M10.6131 3.89171L2.38823 18.0983C1.93203 18.8863 1.70393 19.2803 1.73764 19.6037C1.76705 19.8857 1.91482 20.142 2.14417 20.3088C2.40713 20.5 2.86239 20.5 3.77292 20.5H20.2227C21.1332 20.5 21.5885 20.5 21.8514 20.3088C22.0808 20.142 22.2286 19.8857 22.258 19.6037C22.2917 19.2803 22.0636 18.8863 21.6074 18.0983L13.3825 3.89171C12.9279 3.10654 12.7006 2.71396 12.4041 2.58211C12.1454 2.4671 11.8502 2.4671 11.5915 2.58211C11.295 2.71396 11.0677 3.10655 10.6131 3.89171Z",
    stroke: "#EF0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.bf47f71f1d68a334c6e13250bc44eb9f.svg";
export { ForwardRef as ReactComponent };